import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor(
    private router:Router
  ) { }

  ngOnInit(): void {
  }

  navigate(type:any){
  if(type=='terms'){
    this.router.navigate([`/terms-and-condition`])
  }else{
    this.router.navigate([`/privacy-policy`])
  }
  }

}
